var _linearGradient, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatformAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 619,
    viewBox: "0 0 619 619",
    width: 619,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 13.929,
    x2: 605.386,
    y1: 605.265,
    y2: 13.8068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30796c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopColor: "#44aca6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m539.777 619h3.711c38.715 0 70.522-28.997 74.976-66.508l.536-251.295c-4.401-167.094-141.26-301.197-309.445-301.197-170.963 0-309.555 138.568-309.555 309.5 0 169.103 135.642 306.578 304.077 309.5z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m234.149 123c-2.166 0-4.333.827-5.982 2.473-3.3 3.292-3.3 8.644 0 11.936l22.177 22.124c-25.179 18.432-41.578 48.09-41.578 81.638h203.063c0-33.548-16.399-63.206-41.578-81.638l22.177-22.124c3.3-3.309 3.3-8.627 0-11.936-3.299-3.292-8.664-3.292-11.964 0l-25.086 25.025c-13.595-6.741-28.866-10.616-45.081-10.616-16.214 0-31.485 3.875-45.081 10.616l-25.085-25.025c-1.65-1.646-3.816-2.473-5.982-2.473zm25.383 67.526h16.922v16.882h-16.922zm84.609 0h16.922v16.882h-16.922zm-169.219 67.526c-9.341 0-16.922 7.563-16.922 16.882v101.289c0 9.319 7.581 16.882 16.922 16.882s16.922-7.563 16.922-16.882v-101.289c0-9.319-7.581-16.882-16.922-16.882zm33.844 0v135.053c0 9.318 7.581 16.881 16.922 16.881h16.922v59.086c0 13.977 11.371 25.322 25.383 25.322 14.011 0 25.382-11.345 25.382-25.322v-59.086h33.844v59.086c0 13.977 11.372 25.322 25.383 25.322 14.012 0 25.383-11.345 25.383-25.322v-59.086h16.922c9.341 0 16.922-7.563 16.922-16.881v-135.053zm236.907 0c-9.341 0-16.922 7.563-16.922 16.882v101.289c0 9.319 7.581 16.882 16.922 16.882s16.922-7.563 16.922-16.882v-101.289c0-9.319-7.581-16.882-16.922-16.882z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformAndroid);
export default __webpack_public_path__ + "static/media/platform-android.b121defc0eea2016cc8c789586bb38b7.svg";
export { ForwardRef as ReactComponent };